import styled from 'styled-components'

export const Root = styled.div`
  max-width: 30rem;
`

export const Body = styled.div`
  * + * {
    margin-top: 1rem;
  }
`
